module.exports = __webpack_public_path__ + "img/xtnl-004.3602e260.jpg";